import View from '../view';
import { Modal } from '@mui/material';
import './index.css';
import constants from '../../constants';
import useTheme from '../../utilities/hooks/theme';
import Text from '../text';

const MinigamesScoreModal = ({
  visible,
  onPressDismiss,
  lastScore = 0,
  highScore = 0,
  onPressPlayAgain
}: any) => {
  const { MoreTheme: theme } = useTheme();
  const surfaceStyle = {
    background: theme.minigamesScoreModalBg,
    boxShadow: theme.minigamesScoreModalBoxShadow,
    border: `2px solid ${theme.minigamesScoreModalBorder}`
  };
  const playGameBtnStyle = {
    background: theme.minigamesPlayBtnBg,
    border: `1px solid ${theme.minigamesPlayBtnBorder}`
  };
  const LeaveGameBtnStyle = {
    background: 'transparent',
    border: '1px solid #ffc400',
    color: '#ffc400'
  };

  return (
    <Modal open={visible} onClose={onPressDismiss}>
      <View className="minigames__score__modal" style={surfaceStyle}>
        <Text className="minigames__score__modal__score__text">Your Last Score</Text>
        <View className="minigames__score__modal__ribbon__container">
          <img className="minigames__score__modal__ribbon" src={constants.Images.lastScoreRibbon} />
          <Text className="minigames__score__modal__score">{lastScore}</Text>
        </View>
        <Text className="minigames__score__modal__score__text">Your Highest Score</Text>
        <View className="minigames__score__modal__ribbon__container">
          <img className="minigames__score__modal__ribbon" src={constants.Images.highScoreRibbon} />
          <Text className="minigames__score__modal__score">{highScore}</Text>
        </View>
        <View className="minigames__score__modal__btn__wrapper">
          <button
            className="minigames__score__modal__btn"
            style={LeaveGameBtnStyle}
            onClick={onPressDismiss}>
            Leave Game
          </button>
          <button
            className="minigames__score__modal__btn"
            style={playGameBtnStyle}
            onClick={onPressPlayAgain}>
            Play Again
          </button>
        </View>
      </View>
    </Modal>
  );
};

export default MinigamesScoreModal;
